const FontFaceObserver = require('fontfaceobserver');

const fontsData = {
  // 'Ivar Display Condensed': { weight: 300 },
  // 'Graphik': { weight: 'normal' },
};

const defaultFonts = [
  // 'Ivar Display Condensed',
	// 'Graphik'
]

function loadFonts(fonts = defaultFonts) {
  return new Promise((resolve) => {
    const fontFaceObersvers = fonts.map(font => {
      const data = fontsData[font];
      return new FontFaceObserver(font, data);
    })
    Promise.all(fontFaceObersvers).then(() => {
      resolve()
    });
  })
}

export default loadFonts;